/**
 *
 * @param {*} requireContext
 * @return {{path: String, data: *}}
 * @example
 * let modules = requireAll(require.context("./../lang/", true, /\.json$/));
 * console.log(modules);
 */
export default (requireContext) => requireContext.keys()
  .sortBy((path) => path.split("/").length)
  .map((path) => ({
    path,
    data: requireContext(path),
  }));
